import React from 'react';

import t from '../../../labels/labelling-utils';
import { placeholdersMap, TEAMLOGO } from '../../../utils/placeholders-football';
import Cta from '../../atoms/cta/cta';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import Table, { IColumn, IRow } from '../../molecules/table/table';

import './top-scorers-table.scss';

// ROW interface
export interface ITopScorersRow extends IRow {
  areaIn: number;
  areaOut: number;
  goal: number;
  head: number;
  logoLink?: JSX.Element; // COMPUTED field (generated with MAPPING)
  logoUrl: string;
  penalty: number;
  playerLink?: JSX.Element; // COMPUTED field (generated with MAPPING)
  playerUrl?: string;
  position: number;
  playerName: string;
}

export interface ITopScorersTable {
  rows: ITopScorersRow[];
  className?: string;
  showTitles?: boolean;
  pagination?: object;
}

const TopScorersTable = ({
  /* istanbul ignore next: default value */ rows = [],
  /* istanbul ignore next: default value */ className = 'top-scorers',
  /* istanbul ignore next: default value */ showTitles = true,
  /* istanbul ignore next: default value */ pagination = {},
}: ITopScorersTable) => {
  const columns: IColumn[] = [
    {
      title: `${t('top.scorers.th.position')}`,
      data: 'position',
      classModifier: 'position',
    },
    {
      title: `${t('top.scorers.th.logo')}`, // ISS-4676 - SEO do not allow for EMPTY TH
      data: 'logoLink', // COMPUTED field (generated with MAPPING)
      colspan: 1,
      classModifier: 'logo',
    },
    {
      title: `${t('top.scorers.th.name')}`,
      data: 'playerLink', // COMPUTED field (generated with MAPPING)
      colspan: 2,
      classModifier: 'name',
    },
    {
      title: `${t('top.scorers.th.goal')}`,
      data: 'goal',
      classModifier: 'goal',
    },
    {
      title: `${t('top.scorers.th.penalty')}`,
      data: 'penalty',
      classModifier: 'mobile',
    },
    {
      title: `${t('top.scorers.th.head')}`,
      data: 'head',
      classModifier: 'mobile',
    },
    {
      title: `${t('top.scorers.th.area.in')}`,
      data: 'areaIn',
      classModifier: 'mobile',
    },
    {
      title: `${t('top.scorers.th.area.out')}`,
      data: 'areaOut',
      classModifier: 'mobile-last',
    },
    {
      // EMPTY COLUMN
      title: ' ',
      classModifier: 'last',
    },
  ];

  const _rows: ITopScorersRow[] = rows.map((item: ITopScorersRow) => ({
    ...item,
    logoLink: <ImgPlaceholder src={item.logoUrl} placeholder={placeholdersMap[TEAMLOGO]} loading="lazy" aria-hidden />,
    playerLink:
      item.playerUrl === undefined ? (
        <React.Fragment>{item.playerName}</React.Fragment>
      ) : (
        <Cta href={item.playerUrl} uppercase={false} narrow hasWrapper={false}>
          {item.playerName}
        </Cta>
      ),
  }));

  return <Table columns={columns} rows={_rows} className={className} showTitles={showTitles} />;
};

export default TopScorersTable;
